"use client"

import React, { useState } from "react"
import { logout } from "lib/api"
import type { LocaleType } from "lib/apollo/types"
import { LoginLink } from "../LoginLink"
import { ProfileButton } from "./ProfileButton"
import { container } from "./ProfileMenuContainer.css"
import { UserMenu } from "./UserMenu"

type Props = {
  locale: LocaleType
  isLoggedIn: boolean
  showNotification?: boolean
}

export const ProfileMenuContainer: React.FC<Props> = ({
  locale,
  isLoggedIn,
  showNotification,
}) => {
  const [showUserMenu, setShowUserMenu] = useState(false)

  const onProfileButtonClick = () => {
    setShowUserMenu(!showUserMenu)
  }

  const onLogout = async () => {
    await logout()
    window.location.reload()
  }

  return (
    <div className={container}>
      {isLoggedIn ? (
        <>
          <ProfileButton
            onClick={onProfileButtonClick}
            showNotification={showNotification}
          />
          {showUserMenu && (
            <>
              <UserMenu
                locale={locale}
                toggleUserMenu={onProfileButtonClick}
                onLogout={onLogout}
                showNotification={showNotification}
              />
            </>
          )}
        </>
      ) : (
        <LoginLink locale={locale} />
      )}
    </div>
  )
}
